
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toss/service",
      function () {
        return require("private-next-pages/toss/service/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toss/service"])
      });
    }
  